<template>
<div class="h-screen md:flex">
    <div
      class="relative h-full rounded-none overflow-hidden md:flex w-1/2 bg-gradient-to-tr from-flyingeye to-blue-500 i justify-around items-center hidden !cursor-default">
      <div>
        <h1 class="text-white font-bold text-6xl font-sans">
          <svg class="w-full fill-white max-w-[300px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1509.89 382.24">
            <g>
              <path
                d="m377.73,144.57l-55.13,13.93c4.28,21.54,4.01,43.84-.79,65.26l55.15,13.91c6.76-30.57,7.02-62.4.77-93.1Zm-373.05-.84c-6.49,31.24-6.22,63.68.79,94.79l55.15-13.92c-5.04-21.95-5.31-44.87-.79-66.96l-55.15-13.91Z" />
              <path class="fill-[#7cb1de]"
                d="m308.02,220.28c4.31-19.12,4.58-39.05.79-58.3l-48.27,12.18c2.08,11.24,1.81,22.83-.79,33.94l48.26,12.18h0Zm-186.1-46.97c-2.32,11.78-2.05,23.98.79,35.63l-48.27,12.18c-4.55-19.66-4.82-40.2-.79-59.99l48.26,12.18h0Z" />
              <path
                d="m325.07,56.73c-9.93-9.79-20.81-18.42-32.43-25.73l-29.9,47.43c7.98,5.07,15.45,11.03,22.29,17.77,7.53,7.39,14.2,15.75,19.86,24.88l48.11-29.46c-7.98-12.8-17.36-24.51-27.94-34.89ZM28.27,290.49c7.68,11.94,16.58,22.9,26.53,32.67,10.97,10.81,23.08,20.19,36.07,27.95l29.9-47.43c-9.35-5.52-18.05-12.23-25.92-19.98-6.91-6.79-13.11-14.4-18.46-22.67l-48.13,29.46Z" />
              <path class="fill-[#7cb1de]"
                d="m275.03,110.85c-6.11-5.67-12.74-10.66-19.78-14.89l-26.16,39.18c3.87,2.39,7.52,5.17,10.91,8.31,4.08,3.78,7.7,8.1,10.77,12.86l42.1-24.34c-5.12-7.81-11.11-14.9-17.84-21.12Zm-135.13,125.74c4.42,4.1,9.3,7.6,14.51,10.4l-26.16,39.18c-8.39-4.65-16.24-10.36-23.39-17-6.12-5.66-11.64-12.05-16.45-19.03l42.1-24.34c2.76,3.95,5.9,7.56,9.38,10.79Z" />
              <path
                d="m327.44,323.13c9.77-9.6,18.52-20.33,26.1-32.01l-48.13-29.44c-5.26,8.01-11.3,15.39-18.03,22-7.68,7.55-16.15,14.11-25.24,19.55l29.9,47.43c12.73-7.68,24.61-16.92,35.39-27.53ZM90.35,30.54c-11.9,7.4-23.01,16.17-33.16,26.15-10.75,10.56-20.26,22.51-28.33,35.56l48.11,29.47c5.75-9.4,12.57-17.99,20.29-25.57,7.04-6.93,14.75-13.04,22.99-18.2l-29.9-47.42Z" />
              <path class="fill-[#7cb1de]"
                d="m277.4,269.11c5.93-5.49,11.3-11.66,16.01-18.4l-42.1-24.34c-2.65,3.71-5.65,7.12-8.94,10.18-4.22,3.92-8.86,7.28-13.82,10.02l26.15,39.1c8.13-4.57,15.75-10.12,22.7-16.57Zm-123.55-134.45c-4.12,2.47-8,5.38-11.58,8.7-4.27,3.95-8.03,8.49-11.18,13.51l-42.11-24.34c5.21-8.06,11.34-15.37,18.26-21.76,6.31-5.86,13.17-10.98,20.46-15.3l26.15,39.17v.03Z" />
              <path
                d="m148.04,4.51l12.9,55.16c19.97-4.29,40.54-4.02,60.41.77l12.88-55.16c-28.36-6.76-57.73-7.02-86.19-.77Zm-.78,373.05c28.97,6.49,58.89,6.22,87.76-.79l-12.89-55.16c-20.37,5.05-41.51,5.32-61.98.79l-12.88,55.16Z" />
              <path class="fill-[#7cb1de]"
                d="m164.14,79l11.28,45.99c10.42-1.99,21.09-1.74,31.42.72l11.28-45.99c-17.77-4.1-36.12-4.35-53.97-.73Zm10.49,178.11c10.93,2.2,22.16,1.94,32.99-.77l11.29,45.97c-18.27,4.34-37.17,4.6-55.54.76l11.28-45.99-.02.03Z" />
            </g>
            <g>
              <polygon
                points="461.92 69.32 461.92 94.66 461.92 165.7 490.41 165.7 490.41 94.66 610.31 94.66 610.31 66.16 461.92 66.16 461.92 69.32" />
              <rect x="461.92" y="0" width="155.36" height="28.49" />
            </g>
            <polygon
              points="663.42 138.32 663.42 0 634.92 0 634.92 138.32 634.92 155.37 634.92 166.81 788 166.81 788 138.32 663.42 138.32" />
            <polygon
              points="982.79 0 942.5 0 870.73 71.77 799.15 .19 758.85 0 781.43 22.77 856.86 98.2 856.86 165.7 885.35 165.7 885.35 97.45 961.43 21.37 982.79 0" />
            <rect x="1002.19" y="0" width="28.49" height="165.69" />
            <polygon
              points="1256.93 0 1256.93 136.52 1175.96 53.64 1175.94 53.66 1123.53 0 1103.85 0 1084.16 0 1084.16 165.7 1112.66 165.7 1112.66 29.18 1193.63 112.06 1193.64 112.04 1246.06 165.7 1256.93 165.69 1256.93 165.7 1285.42 165.7 1285.42 0 1256.93 0" />
            <path
              d="m1402.86,77.55h106.96v39.37s4.69,48.78-58.69,48.78h-85.21s-52.31,1.11-52.31-48.24c0-68.02,0-45.44,0-74.16,0,0-2.97-43.29,51.51-43.29h105.17s39.54-1.47,39.54,35.74c0,13.48.08,20.28.08,20.28h-28.57v-15.16s.55-14.29-20.21-14.29h-101.39s-20.07-1.16-20.07,27.06v56.03s.66,28.82,28.97,28.82h82.25s29.39,2.49,29.39-24.37v-11.49h-77.43l.03-25.08Z" />
            <polygon class="fill-[#7cb1de]"
              points="583.22 216.55 583.22 282.7 489.01 282.7 489.01 216.55 460.51 216.55 460.51 282.7 460.51 311.2 460.51 382.24 489.01 382.24 489.01 311.2 583.22 311.2 583.22 382.24 611.72 382.24 611.72 311.2 611.72 282.7 611.72 216.55 583.22 216.55" />
            <path class="fill-[#7cb1de]"
              d="m705.14,382.18c-13.88-.07-23.99-7.63-30.73-20.22-2.92-5.46-4.07-11.42-4.06-17.7.04-42.59.02-85.16.02-127.75h29.26c0,41.23,0,82.46,0,123.69,0,3.84,1.04,7.1,4.13,9.42,1.88,1.41,4.01,1.82,6.25,1.82l73.49.02c4.32,0,7.79-1.51,9.54-5.87.64-1.57.83-3.45.84-5.19.19-41.28.23-82.54.29-123.82h29.27c-.04,42.66-.07,85.32-.13,127.97-.03,18.15-11.07,32.85-27.69,36.87-2.18.53-4.45.83-6.69.83l-83.79-.06Z" />
            <path class="fill-[#7cb1de]"
              d="m882.06,382.21v-165.66h134.46c17.77,0,33.04,14.16,35.31,32.92.47,3.88.34,7.85.34,11.78.35,14.31-.11,29.58-12.45,38.54,14.46,11.81,12.64,28.53,12.41,45.79-.23,19.93-16.43,36.93-36.17,36.65,0,0-133.91-.03-133.91-.03Zm28.93-134.84v38.69l106.41-.07c3.17-1.66,5.72-4.08,5.84-8.01.22-7.32.2-14.66.01-21.98-.1-3.93-2.77-7.1-6.38-8.11-1.35-.38-2.8-.5-4.2-.5l-101.68-.02Zm-.07,65.71v38.32l103.42-.02c4.82-.31,8.7-3.68,8.88-8.46.27-7.21.23-14.44,0-21.66-.12-4-4.33-8.26-7.54-8.26l-104.76.08Z" />
          </svg>
          <span class="hidden">
            FlyingHub
          </span>
        </h1>
        <!-- <p class="text-white mt-1 text-lg">
          The most popular peer to peer lending at SEA
        </p> -->
        <a href="https://www.flyingeye.fr/product/flyinghub/"
          class="block cursor-pointer w-fit bg-white text-flyingeye mt-4 py-2 px-6 rounded-2xl font-bold text-base mb-2 hover:text-flyingeye-light"
          target="_blank" rel="noopener noreferrer">
          {{ $e("Plus d'information") }}
        </a>
      </div>
      <div class="absolute -bottom-32 -left-40 w-80 h-80 border-4 rounded-full border-opacity-30 border-t-8"></div>
      <div class="absolute -bottom-40 -left-20 w-80 h-80 border-4 rounded-full border-opacity-30 border-t-8"></div>
      <div class="absolute -top-40 -right-0 w-80 h-80 border-4 rounded-full border-opacity-30 border-t-8"></div>
      <div class="absolute -top-20 -right-20 w-80 h-80 border-4 rounded-full border-opacity-30 border-t-8"></div>
    </div>
    <div class="flex md:w-1/2 justify-center py-10 items-center bg-g0 text-white px-8">
      <form class="mx-10 mx-auto" @submit.prevent="$emit('login')" v-if="!config.lost">
        <div v-html="LogoForm"></div>

        <!-- ERROR -->
        <div v-if="config.error != false" class="text-sm text-red-500 mt-7 lg:max-w-md">
          {{ $e(config.error) }}
        </div>
        <!-- END -->

        <div class="flex items-center border-2 py-2 px-3 rounded-2xl mb-4 mt-7 bg-g1">
          <label for="email">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
            </svg>
          </label>
          <input class="ml-2 pl-2 outline-none border-none w-full !bg-transparent placeholder:text-g3" v-model="config.email"
            type="text" name="email" id="" placeholder="Email" autocomplete="email" required @focus="config.error = false" />
        </div>

        <div class="flex items-center border-2 py-2 px-3 rounded-2xl bg-g1">
          <label for="password">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                clip-rule="evenodd" />
            </svg>
          </label>
          <input class="ml-2 pl-2 outline-none border-none w-full !bg-transparent placeholder:text-g3" type="password"
            name="password" id="password" :placeholder="$e('Mot de passe')" autocomplete="password" v-model="config.password"
            required @focus="config.error = false" @focusin="(event) => { event.target.type = 'text'; }"
            @focusout="(event) => { event.target.type = 'password' }" />
        </div>

        <span class=" block text-sm mt-5 text-g3 hover:text-flyingeye-light cursor-pointer"
          @click.prevent="config.lost = true">
          {{ $e("Mot de passe oublié ?") }}
        </span>
        <button type="submit"
          class="block w-full bg-flyingeye mt-5 py-2 rounded-2xl text-white font-semibold mb-2 flex items-center justify-center"
          :class="{ 'bg-g2 opacity-40 cursor-not-allowed': config.email == '' || config.password == '' }"
          :disabled="config.email == '' || config.password == ''">
          {{ $e("Connexion") }}

          <svg v-if="config.load" class="float-right animate-spin ml-3 w-[18px] text-white" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>
        </button>
      </form>

      <form class="mx-10 mx-auto" @submit.prevent="$emit('resetPassword')" v-else>
        <div v-html="LogoForm"></div>



        <p class="mt-7">{{ $e("Mot de passe oublié ?") }}</p>
        <div class="flex items-center border-2 py-2 px-3 rounded-2xl mb-4 mt-2 bg-g1">
          <label for="email">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
            </svg>
          </label>
          <input class="ml-2 pl-2 outline-none border-none w-full !bg-transparent placeholder:text-g3" type="text"
            name="email" id="email" placeholder="Email" autocomplete="email" v-model="config.email" required />
        </div>
        <button type="submit" class="block w-full bg-flyingeye mt-5 py-2 rounded-2xl text-white font-semibold mb-2"
          :class="{ 'bg-g2': config.email == '' }" :disabled="config.email == ''">
          {{ $e("Récupérer mon mot de passe") }}
        </button>
        <span class="block text-sm mt-5 text-g3 hover:text-flyingeye-light cursor-pointer"
          @click.prevent="config.lost = false">
          {{ $e("Retour") }}
        </span>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "WEB",
  props: {
    config : {
      type: Object,
      default: () => ({
        email: '',
        password: '',
        error: false,
        load: false,
        lost: false,
      }),
    },
  },
};
</script>